module.exports = __webpack_public_path__ + "static/media/Z1.a6e41c81.jpg";